import { CubeSaveGenericServices } from "./api-connector";
import { ResponseHandler } from "@green24/npm-javascript-utils";

class SettingsServices extends CubeSaveGenericServices {
	getItem(locationID, processor = data => data, signal, additionalConfiguration) {
		return this.sendRequest(this.url + `?locationID=${locationID}`);
	}

	getTermsPDF(locationID) {
		return this.sendRequest({
			url: `${this.url}/terms/pdf?locationID=${locationID}`,
		}, ResponseHandler.blob);
	}
}

export const settingsServices = new SettingsServices(`/settings`);
